import { getOrgAndIntroducerAndAdvisorFiltersDiscovery } from '../api/org_introducer_advisor_filters'
import type { Resolvers } from '../generated/server/resolvers'

const OrgAndIntroducerAndAdvisorFilter: Resolvers = {
  Query: {
    orgAndIntroducerAndAdvisorFiltersDiscovery: (_parent, { input }) =>
      getOrgAndIntroducerAndAdvisorFiltersDiscovery(input),
  },
}

export default OrgAndIntroducerAndAdvisorFilter
